var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('marionette');
var ROWS = 10;
var $ = require('jquery');
var Labels = EY.Consultation.Labels;

var Pager = Backbone.Model.extend({
    defaults: {
        current: '',
        direction: '',
        next: '',
        previous: '',
        sort: '',
        total: '-'
    }
});

var Pagination = Marionette.View.extend({
    events: {
        'blur @ui.current': 'current',
        'click @ui.first': function () { this.model.set('current', 1); },
        'click @ui.last': function () { this.model.set('current', this.model.get('total')); },
        'click @ui.next': function () { this.model.get('current') < this.model.get('total') ? this.model.set('current', this.model.get('current') + 1) : ''; },
        'click @ui.previous': function () { this.model.get('current') > 1 ? this.model.set('current', this.model.get('current') - 1) : ''; }
    },
    modelEvents: {
        'change:current': 'page',
        'change:total': function () { this.ui.total.html(this.model.get('total')); }
    },
    template: '#pagination',
    ui: {
        current: '#current',
        first: '#first',
        last: '#last',
        next: '#next',
        previous: '#previous',
        total: '#total',
        itemCount: '#itemCount'
    },
    onRender: function () { this.page(); },
    current: function () {
        var page = parseInt(_.escape(this.ui.current.val()));

        if (page > 0 && page <= this.model.get('total')) {
            this.model.set('current', page);
        } else {
            this.ui.current.val(this.model.get('current'));
        }
    },
    page: function () {
        var current = this.model.get('current');
        var itemCount = this.model.get('itemCount') || 0;
        this.ui.itemCount.text(EY.Consultation.Labels.Count + ': ' + itemCount);

        if (_.isNumber(current)) {
            var query = this.options.queries.findWhere({ selected: true });

            if (query) {
                var aggregate = query.get('aggregate');
                var fetch = {
                    filter: query.get('filter'),
                    page: current,
                    reset: true,
                    rows: ROWS,
                    select: query.get('select'),
                    sort: this.model.get('sort') && this.model.get('direction') ? _.object([this.model.get('sort')], [this.model.get('direction') === 'descending' ? -1 : 1]) : {}
                };

                if (!_.isEmpty(aggregate)) {
                    aggregate = _.isEmpty(fetch.sort) ? aggregate : aggregate.concat([{ $sort: fetch.sort }]);
                    aggregate = _.isEmpty(fetch.select) ? aggregate : aggregate.concat([{ $project: fetch.select }]);
                    fetch.aggregate = aggregate.concat([{ $skip: (current - 1) * ROWS }, { $limit: ROWS }]);

                    // TODO: --SQ Elevate to MongoDB API Controller!!!
                    _.extend(fetch, { filter: {}, select: {}, sort: {}, page: 1, rows: 0 });
                }
                this.collection.fetch(fetch);
            }
        }
        this.ui.current.val(current);
    }
});

var configure = function (options) {
    var pager = options.model;
    var query = options.queries.findWhere({ selected: true });
    var rows = options.rows;
    var setDefaultSort = !pager.get('sort') && !!options.defaultSort; 

    if (query) {
        var aggregate = (_.isEmpty(query.get('aggregate')) ? [{ $match: query.get('filter') }] : query.get('aggregate')).concat({ $count: 'count' });

        rows.clone().fetch({ aggregate: aggregate }).done(function (items) {
            var count = items.length ? _.first(items).count : 0;
            var pageCount = items.length ? _.first(items).pageCount || _.first(items).count : 0;
            options.queries.trigger('fetchComplete');
            rows.reset();
            pager.set({ current: '-', total: '-', itemCount: count });
            setDefaultSort && pager.set({  direction: options.defaultSort.direction, sort: options.defaultSort.colName });
            query.set('count', count);
            if (count) {
                pager.set({ current: 1, total: Math.ceil(pageCount / ROWS) });
            } else {
                // US-243769: Below change is made to remove the default behaviour of grid displaying 'No data found' msg
                // during the search before displaying the actual records.
                $("#homegrid table tbody").html("<tr class='empty'><td colspan='10'><span>"+ Labels.NoDataFound +"</span></td></tr>");
            }
        });
    }
};

module.exports.show = function (options) {
    var pager = new Pager();
    var queries = options.queries;
    var region = options.region;
    var rows = options.rows;

    options = _.extend({}, options, {
        collection: rows,
        model: pager
    });
    region.show(new Pagination(options));
    configure(options);
    queries.on('change:selected', function (query) {
        if (query.get('selected')) {
            configure(options);
        }
    });
    rows.on('backgrid:sort', function (column, direction) {
        pager.set({ current: '-' });
        pager.set({ current: 1, direction: direction, sort: column.attributes.name });
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Service/Pagination.js